import { CampoDinamico } from '../campo-dinamico';

export class Sezione {
  campiDinamici: CampoDinamico[];
  id: string;
  tipoSezione: any;
  idParent: string;
  nomeCampoId: string;
  isMain: boolean;
  nomeSezione: string;
  fascicoloId: string;
  esn: string;
  documenti: any[];

  writable: boolean;
}
